export const SITE_NAME = 'CSSBuy Spreadsheet';
export const SITE_URL: string = (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://cssbuybr.my';
export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

const HERO_HOME =
  'https://readdy.ai/api/search-image?query=Editorial%20streetwear%20fashion%20scene%20with%20sneakers%20hoodies%20and%20accessories%20styled%20on%20a%20concrete%20urban%20backdrop%2C%20moody%20cinematic%20lighting%2C%20deep%20teal%20and%20amber%20tones%2C%20premium%20ecommerce%20hero%20photography&width=1600&height=900&seq=hero-bg-02&orientation=landscape&nocache=true';

const HERO_SPREADSHEET =
  'https://readdy.ai/api/search-image?query=Minimalist%20overhead%20view%20of%20organized%20fashion%20products%20grid%20arrangement%20soft%20neutral%20linen%20background%20warm%20natural%20light%20editorial%20photography%20clean%20aesthetic%20product%20spreadsheet%20concept%20premium%20quality&width=1200&height=500&seq=article-hero-spreadsheet&orientation=landscape';

const HERO_SHIPPING =
  'https://readdy.ai/api/search-image?query=Minimalist%20shipping%20packages%20stacked%20on%20soft%20neutral%20linen%20surface%20with%20shipping%20labels%20warm%20natural%20light%20editorial%20photography%20clean%20aesthetic%20logistics%20delivery%20concept%20premium%20quality&width=1200&height=500&seq=article-hero-shipping&orientation=landscape';

const HERO_SAFETY =
  'https://readdy.ai/api/search-image?query=Minimalist%20security%20shield%20and%20padlock%20on%20soft%20neutral%20linen%20background%20warm%20natural%20light%20editorial%20product%20photography%20clean%20aesthetic%20safety%20protection%20trust%20concept%20premium%20quality&width=1200&height=500&seq=article-hero-safety&orientation=landscape';

const HERO_REVIEW =
  'https://readdy.ai/api/search-image?query=Five%20gold%20rating%20stars%20floating%20above%20a%20clean%20desk%20with%20a%20tablet%20and%20notes%2C%20warm%20amber%20studio%20lighting%2C%20premium%20review%20concept%20photography%2C%20soft%20gradient%20background&width=1200&height=500&seq=art-hero-review&orientation=landscape';

const HERO_COUPON =
  'https://readdy.ai/api/search-image?query=Gift%20voucher%20and%20discount%20tag%20with%20scissors%20on%20a%20coral%20pink%20background%2C%20playful%20ecommerce%20sale%20concept%2C%20bright%20studio%20lighting%2C%20clean%20minimal%20composition&width=1200&height=500&seq=art-hero-coupon&orientation=landscape';

const HERO_WAREHOUSE =
  'https://readdy.ai/api/search-image?query=Neat%20rows%20of%20cardboard%20parcels%20on%20industrial%20shelving%20in%20a%20bright%20modern%20warehouse%2C%20soft%20daylight%2C%20logistics%20storage%20concept%2C%20clean%20organized%20composition&width=1200&height=500&seq=art-hero-warehouse&orientation=landscape';

const HERO_QC =
  'https://readdy.ai/api/search-image?query=Magnifying%20glass%20inspecting%20a%20folded%20garment%20on%20a%20sage%20green%20table%2C%20quality%20control%20inspection%20concept%2C%20soft%20natural%20window%20light%2C%20editorial%20product%20photography&width=1200&height=500&seq=art-hero-qc&orientation=landscape';

const HERO_ALTERNATIVES =
  'https://readdy.ai/api/search-image?query=Two%20paths%20splitting%20on%20a%20minimal%20teal%20background%20with%20arrows%20pointing%20in%20different%20directions%2C%20choice%20and%20comparison%20concept%2C%20clean%20flat%20illustration%20style&width=1200&height=500&seq=art-hero-alternatives&orientation=landscape';

const HERO_BEGINNER =
  'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20step%20by%20step%20checklist%20and%20coffee%20on%20a%20warm%20cream%20desk%2C%20learning%20and%20getting%20started%20concept%2C%20cozy%20natural%20light%2C%20editorial%20photography&width=1200&height=500&seq=art-hero-beginner&orientation=landscape';

const HERO_BRAZIL =
  'https://readdy.ai/api/search-image?query=Cardboard%20parcel%20with%20green%20and%20yellow%20ribbon%20on%20a%20wooden%20table%2C%20Brazil%20shipping%20concept%2C%20warm%20tropical%20light%2C%20clean%20product%20photography&width=1200&height=500&seq=art-hero-brazil&orientation=landscape';

const HERO_GERMANY =
  'https://readdy.ai/api/search-image?query=Cardboard%20parcel%20with%20black%20red%20and%20gold%20ribbon%20on%20a%20slate%20table%2C%20Germany%20shipping%20concept%2C%20cool%20studio%20lighting%2C%20clean%20product%20photography&width=1200&height=500&seq=art-hero-germany&orientation=landscape';

const HERO_SHOES =
  'https://readdy.ai/api/search-image?query=Colorful%20sneakers%20arranged%20in%20a%20row%20on%20a%20light%20concrete%20surface%2C%20vibrant%20footwear%20photography%2C%20bright%20studio%20lighting%2C%20energetic%20streetwear%20composition&width=1200&height=500&seq=art-hero-shoes&orientation=landscape';

const HERO_HOODIES =
  'https://readdy.ai/api/search-image?query=Stack%20of%20folded%20pastel%20hoodies%20on%20a%20soft%20lavender%20background%2C%20cozy%20fashion%20photography%2C%20gentle%20natural%20light%2C%20clean%20minimal%20composition&width=1200&height=500&seq=art-hero-hoodies&orientation=landscape';

export type SchemaType = 'home' | 'article' | 'products' | 'faq' | 'static';

export interface RouteSeo {
  path: string;
  title: string;
  description: string;
  keywords: string;
  image?: string;
  datePublished?: string;
  dateModified?: string;
  schemaType: SchemaType;
}

export const routeSeoMap: Record<string, RouteSeo> = {
  '/': {
    path: '/',
    title: 'CSSBuy Spreadsheet 2026 — Find and Compare Products | cssbuybr.my',
    description:
      'Explore CSSBuy Spreadsheet, find products, compare options and see guides on QC, shipping, costs, warehouse, safety and buying. PT-BR, English, Deutsch.',
    keywords: 'CSSBuy Spreadsheet, CSSBuy review, CSSBuy shipping cost, CSSBuy coupon, CSSBuy warehouse, CSSBuy legit',
    image: HERO_HOME,
    dateModified: '2026-08-27',
    schemaType: 'home',
  },
  '/cssbuy-spreadsheet': {
    path: '/cssbuy-spreadsheet',
    title: 'CSSBuy Spreadsheet 2026 — Complete Product & Buying Guide',
    description:
      'Complete guide to the CSSBuy Spreadsheet: how it works, product categories, seller research, QC, shipping cost, warehouse and safety for smarter buying.',
    keywords: 'CSSBuy Spreadsheet, CSSBuy spreadsheet guide, CSSBuy products, CSSBuy categories, CSSBuy buying guide',
    image: HERO_SPREADSHEET,
    datePublished: '2026-08-15',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-spreadsheet-guide': {
    path: '/cssbuy-spreadsheet-guide',
    title: 'CSSBuy Spreadsheet Guide 2026 — How to Find Products',
    description:
      'A practical CSSBuy Spreadsheet guide covering how to find products, compare categories, research sellers and read QC photos before you buy.',
    keywords: 'CSSBuy Spreadsheet guide, how to use CSSBuy Spreadsheet, CSSBuy products, CSSBuy categories',
    image: HERO_SPREADSHEET,
    datePublished: '2026-08-15',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-shipping-guide': {
    path: '/cssbuy-shipping-guide',
    title: 'CSSBuy Shipping Cost Guide 2026 — Methods & Pricing',
    description:
      'Understand CSSBuy shipping cost, methods and pricing by weight, dimensions and destination, plus how to save by consolidating your orders.',
    keywords: 'CSSBuy shipping cost, CSSBuy shipping, CSSBuy shipping calculator, CSSBuy volumetric weight',
    image: HERO_SHIPPING,
    datePublished: '2026-08-16',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-safety-guide': {
    path: '/cssbuy-safety-guide',
    title: 'Is CSSBuy Legit and Safe? — CSSBuy Safety Guide 2026',
    description:
      'Is CSSBuy legit and safe? Read our safety guide covering seller risks, payment, QC, shipping, customs and refunds before you place an order.',
    keywords: 'Is CSSBuy legit, is CSSBuy safe, CSSBuy safety, CSSBuy risks, CSSBuy buying guide',
    image: HERO_SAFETY,
    datePublished: '2026-08-17',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-review': {
    path: '/cssbuy-review',
    title: 'CSSBuy Review 2026: Fees, QC, Shipping & Safety',
    description:
      'An independent CSSBuy review covering fees, quality control photos, warehouse storage, shipping options and whether CSSBuy is legit and safe.',
    keywords: 'CSSBuy review, CSSBuy review 2026, CSSBuy fees, CSSBuy pros and cons, is CSSBuy legit',
    image: HERO_REVIEW,
    datePublished: '2026-08-18',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-coupon': {
    path: '/cssbuy-coupon',
    title: 'CSSBuy Coupon & Discount Code 2026 Guide',
    description:
      'How CSSBuy coupons and discount codes work, where to find legitimate offers and how to verify a code before checkout.',
    keywords: 'CSSBuy coupon, CSSBuy discount code, CSSBuy promotion, CSSBuy discount',
    image: HERO_COUPON,
    datePublished: '2026-08-19',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-warehouse': {
    path: '/cssbuy-warehouse',
    title: 'CSSBuy Warehouse Guide: Storage, QC & Consolidation',
    description:
      'CSSBuy warehouse guide explaining storage limits, QC inspection, consolidation and repackaging to reduce your shipping cost.',
    keywords: 'CSSBuy warehouse, CSSBuy warehouse storage, CSSBuy consolidation, CSSBuy parcel preparation',
    image: HERO_WAREHOUSE,
    datePublished: '2026-08-20',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-qc': {
    path: '/cssbuy-qc',
    title: 'CSSBuy QC Guide: How to Read QC Photos',
    description:
      'Learn how to read CSSBuy QC photos for shoes, clothing and hoodies so you can catch quality issues before your parcel ships.',
    keywords: 'CSSBuy QC, CSSBuy QC photos, CSSBuy quality control, CSSBuy shoe QC',
    image: HERO_QC,
    datePublished: '2026-08-21',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-alternatives': {
    path: '/cssbuy-alternatives',
    title: 'CSSBuy Alternatives 2026: Superbuy, Sugargoo & More',
    description:
      'Compare CSSBuy with Superbuy, Sugargoo, Oopbuy and AllChinaBuy on fees, shipping and QC to choose the best agent for your country.',
    keywords: 'CSSBuy alternatives, CSSBuy vs Superbuy, CSSBuy vs Sugargoo, CSSBuy comparison',
    image: HERO_ALTERNATIVES,
    datePublished: '2026-08-22',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-beginner-guide': {
    path: '/cssbuy-beginner-guide',
    title: 'How to Use CSSBuy Spreadsheet: Beginner Guide',
    description:
      'A beginner guide to using the CSSBuy Spreadsheet, from understanding categories and finding products to shipping your first package.',
    keywords: 'CSSBuy beginner guide, how to use CSSBuy Spreadsheet, CSSBuy for beginners',
    image: HERO_BEGINNER,
    datePublished: '2026-08-23',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-shipping-brazil': {
    path: '/cssbuy-shipping-brazil',
    title: 'CSSBuy Shipping to Brazil: Costs & Customs Guide',
    description:
      'CSSBuy shipping to Brazil explained: methods, costs, import duties and customs tips so you know the real total before ordering.',
    keywords: 'CSSBuy shipping to Brazil, CSSBuy Brazil, CSSBuy frete, CSSBuy custo de envio',
    image: HERO_BRAZIL,
    datePublished: '2026-08-24',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-shipping-germany': {
    path: '/cssbuy-shipping-germany',
    title: 'CSSBuy Shipping to Germany: Costs & Methods',
    description:
      'CSSBuy shipping to Germany: EMS, DHL and postal methods, pricing, VAT and customs so you can balance speed and cost.',
    keywords: 'CSSBuy shipping to Germany, CSSBuy Germany, CSSBuy Versand, CSSBuy Versandkosten',
    image: HERO_GERMANY,
    datePublished: '2026-08-25',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-spreadsheet-shoes': {
    path: '/cssbuy-spreadsheet-shoes',
    title: 'CSSBuy Spreadsheet Shoes: Best Sneaker Finds',
    description:
      'Find the best shoes and sneakers on the CSSBuy Spreadsheet, plus QC tips and shipping advice for footwear orders.',
    keywords: 'CSSBuy spreadsheet shoes, CSSBuy sneakers, CSSBuy shoe QC, CSSBuy shoe guide',
    image: HERO_SHOES,
    datePublished: '2026-08-26',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/cssbuy-spreadsheet-hoodies': {
    path: '/cssbuy-spreadsheet-hoodies',
    title: 'CSSBuy Spreadsheet Hoodies: Best Finds & Guide',
    description:
      'Find the best hoodies and sweaters on the CSSBuy Spreadsheet, with print QC, sizing and shipping tips for smarter orders.',
    keywords: 'CSSBuy spreadsheet hoodies, CSSBuy hoodie guide, CSSBuy clothing QC, CSSBuy sweaters',
    image: HERO_HOODIES,
    datePublished: '2026-08-27',
    dateModified: '2026-08-27',
    schemaType: 'article',
  },
  '/products': {
    path: '/products',
    title: 'CSSBuy Spreadsheet Products — Browse All Categories',
    description:
      'Browse the full CSSBuy Spreadsheet product catalog across shoes, hoodies, t-shirts, jackets, bags and accessories, with direct links to buy.',
    keywords: 'CSSBuy spreadsheet products, CSSBuy categories, CSSBuy shoes, CSSBuy hoodies, CSSBuy accessories',
    image: HERO_HOME,
    dateModified: '2026-08-27',
    schemaType: 'products',
  },
  '/about': {
    path: '/about',
    title: 'About CSSBuy Spreadsheet — Independent Buying Resource',
    description:
      'Learn about CSSBuy Spreadsheet, an independent resource helping buyers research products, shipping and QC before purchasing.',
    keywords: 'about CSSBuy Spreadsheet, CSSBuy resource, CSSBuy buying guide',
    image: HERO_HOME,
    dateModified: '2026-08-27',
    schemaType: 'static',
  },
  '/contact': {
    path: '/contact',
    title: 'Contact CSSBuy Spreadsheet',
    description:
      'Contact the CSSBuy Spreadsheet team with questions about product research, shipping guides and buying resources.',
    keywords: 'contact CSSBuy Spreadsheet, CSSBuy support, CSSBuy questions',
    image: HERO_HOME,
    dateModified: '2026-08-27',
    schemaType: 'static',
  },
  '/faq': {
    path: '/faq',
    title: 'CSSBuy Spreadsheet FAQ — Common Questions Answered',
    description:
      'Frequently asked questions about CSSBuy Spreadsheet, shipping cost, QC, warehouse, coupons and whether CSSBuy is legit and safe.',
    keywords: 'CSSBuy Spreadsheet FAQ, CSSBuy questions, CSSBuy shipping cost, is CSSBuy legit',
    image: HERO_HOME,
    dateModified: '2026-08-27',
    schemaType: 'faq',
  },
  '/disclaimer': {
    path: '/disclaimer',
    title: 'Disclaimer — CSSBuy Spreadsheet',
    description:
      'Read the CSSBuy Spreadsheet disclaimer about our independent, informational content and external links.',
    keywords: 'CSSBuy disclaimer, CSSBuy independent resource',
    image: HERO_HOME,
    dateModified: '2026-08-27',
    schemaType: 'static',
  },
  '/privacy': {
    path: '/privacy',
    title: 'Privacy Policy — CSSBuy Spreadsheet',
    description:
      'Read the CSSBuy Spreadsheet privacy policy explaining how we handle visitor information on this website.',
    keywords: 'CSSBuy privacy policy, CSSBuy data',
    image: HERO_HOME,
    dateModified: '2026-08-27',
    schemaType: 'static',
  },
  '/terms': {
    path: '/terms',
    title: 'Terms of Service — CSSBuy Spreadsheet',
    description:
      'Read the CSSBuy Spreadsheet terms of service covering use of this independent informational website.',
    keywords: 'CSSBuy terms of service, CSSBuy terms',
    image: HERO_HOME,
    dateModified: '2026-08-27',
    schemaType: 'static',
  },
};

export function getRouteSeo(pathname: string): RouteSeo | null {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/';
  return routeSeoMap[normalized] ?? null;
}

export function buildCanonical(path: string): string {
  const base = SITE_URL.replace(/\/+$/, '');
  return path === '/' ? `${base}/` : `${base}${path}`;
}